<template>
  <div class="account-exist">
    <Icon></Icon>
    <el-collapse-transition>
      <isError v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></isError>
    </el-collapse-transition>
    <Titles></Titles>
    <Account :type="3" :content="$route.query.account" style="margin-top: 45px;"></Account>
    <Inputs :type="'password'" style="margin-top: 45px;" v-on:inputText="getPassword" v-on:enterInput="enterInput"></Inputs>
    <Buttons ref=btn :type="'join'" style="margin-top: 45px;margin-bottom: 115px;" :data="{type: type, password: password, account: account}" v-on:openErrorTip="openErrorTip" v-on:closeErrorTip="closeErrorTip"></Buttons>
  </div>
</template>

<script>
  import Icon from '../components/Icon'
  import isError from '../components/Error'
  import Titles from '../components/Title'
  import Account from '../components/Account'
  import Inputs from '../components/Inputs'
  import Buttons from '../components/Buttons'
  import { errorFn } from '../common/ErrorMsg.js'
  import { checkPhone, checkUsername } from '../common/Common.js'
  export default {
    data () {
      return {
        errorShow: false,
        errorMsg: '',
        password: '',
        type: 0,
        account: this.$route.query.account
      }
    },
    components: {
      Icon: Icon, isError: isError, Titles: Titles, Account: Account, Inputs: Inputs, Buttons: Buttons
    },
    mounted () {
      if (checkPhone(this.$route.query.account)) {
        this.type = 1
      } else if (checkUsername(this.$route.query.account)) {
        this.type = 2
      }
    },
    methods: {
      getPassword (data) {
        this.password = data
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../../assets/css/_mixin.less';
  .account-exist {
    .white-bg();
    min-height: 520px;
    margin-top: -260px;
  }
</style>



// WEBPACK FOOTER //
// Accountexist.vue?2193bca4